import axios from 'axios'
import {REST} from '../api'
import {type FleetConfigKey} from '../store/state/config/state'

const FLEET_CONFIG_BASE_URL = '/api/v1/fleetConfiguration'
const GET_FLEET_CONFIG_FOR_KEY = `${FLEET_CONFIG_BASE_URL}/key`

interface FleetConfig {
    identity: string
    key: string
    value: Record<string, unknown>
    category: Category
    // ISO datetime
    createdAt: string
    updatedAt: string
}

export enum Category {
    System = 'SYSTEM',
    Soc = 'SOC',
}

interface FleetConfigUpsertRequest extends Omit<
    FleetConfig,
    'createdAt' | 'updatedAt' | 'identity'
> {
    identity?: string
}

export async function fetchFleetConfigByKey(key: FleetConfigKey) {
    const res = await REST.get<FleetConfig>(`${GET_FLEET_CONFIG_FOR_KEY}/${key}`)
    return res.data
}

export async function upsertFleetConfig(fleetConfig: FleetConfigUpsertRequest) {
    const newFleetConfig = !fleetConfig.identity
    try {
        const res = newFleetConfig
            ? await REST.post<FleetConfig>(FLEET_CONFIG_BASE_URL, fleetConfig)
            : await REST.put<FleetConfig>(FLEET_CONFIG_BASE_URL, fleetConfig)
        return res.data
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response?.status === 404) {
                // We consider 404 to be no data
                return {} as FleetConfig
            }
        }

        throw error
    }
}

export function isFleetConfigEnabled(config: FleetConfig | undefined) {
    return Boolean(config?.value.enabled)
}
